<mat-form-field [appearance]="appearance" class="fk-w-full">
  <!-- label -->
  <!-- label -->
  <mat-label>
    <base-form-kit-label [label]="label">
      <ng-content select="[label-content]"></ng-content>
    </base-form-kit-label>
  </mat-label>

  <input
    [required]="required"
    [disabled]="isDisabled"
    matInput
    [matDatepicker]="dp"
    [formControl]="control || defaultControl"
    [(ngModel)]="value"
    (dateChange)="emit()"
    (change)="emit()"
    [min]="_min"
    [max]="_max"
    autocomplete="off"
    (click)="dp.open()"
    [ngStyle]="{
      'font-size': fontSize
    }"
  />

  <div class="fk-items-center" matSuffix>
    <mat-datepicker-toggle
      [for]="dp"
      [style.display]="isShowToggle ? 'initial' : 'none'"
    ></mat-datepicker-toggle>

    <validation-icon
      [control]="control"
      [hasMatPrefix]="hasMatPrefix"
      [hasMatSuffix]="hasMatSuffix"
      [value]="value"
      [isShowValidationStatusIcon]="isShowValidationStatusIcon"
    >
    </validation-icon>
  </div>

  <mat-datepicker #dp></mat-datepicker>
</mat-form-field>
